// Config option  quan hệ giao dịch nội bộ - Khách hàng nhà cung cấp
export default {
  IntermAccountingUnitNd: 1, // Đơn vị kế toán trung gian 2
  IntermAccountingUnitSt: 2, // Đơn vị kế toán trung gian 1
  EstimatedUnitsSt: 3, // Đơn vị dự toán cấp 1
  OutEstimatedUnitsStInProv: 4, // Ngoài đơn vị dự toán cấp 1 - trong cùng 1 tỉnh
  OutEstimatedUnitsStDiffProv: 5, // Ngoài đơn vị dự toán cấp 1 (khác tỉnh, khác Bộ, ngành) - trong lĩnh vực kế toán nhà nước
  OutGovernmArea: 6, // Ngoài khu vực nhà nước
};
